import { useQuery } from "@tanstack/react-query"
import { getFinanceReport } from "services/apiReport"

const useGetFinanceReport = (params) => {
    const{isPending,isSuccess,data,refetch} = useQuery({
        queryKey:['customFinanceData',params],
        queryFn:()=> getFinanceReport(params),
        enabled:!!params,
        keepPreviousData:true,
        staleTime: 2 * 60 * 60 * 1000,
    })

    return{isPending,isSuccess,data,refetch}
}

export default useGetFinanceReport
